export const ANNUAL_PAY_TYPE = 'annual';
export const BUILD_BY_MANUAL = 'manual';
export const BUILD_BY_PERCENTAGE = 'percent';
export const BUILD_BY_TARGET = 'target';
export const HOURLY_PAY_TYPE = 'hourly';
export const MANUAL_RANGE_TYPE = 'manual';
export const MARKET_RANGE_TYPE = 'market';
export const MIDPOINT_RANGE_TYPE = 'midpoint';
export const THOUSANDS_PAY_TYPE = 'thousands';
